<template>
    <section class="container py-4">
        <template v-if="!loading">
          <template>
              <div class="d-flex justify-content-center">
                  <img src="/static/img/main-logo.svg" width="140" class="rounded" alt="...">
              </div>
              <div class="d-flex justify-content-center">
                  <div class="text-center mt-4">
                      <h3>เอกสารแสดงความยินยอมให้หักรายได้ในการสั่งซื้อโต๊ะรองรีดผ้า</h3>
                  </div>
              </div>
              <div class="d-flex justify-content-end">
                  <p>วันที่ {{ documentDate }} </p>
              </div>
              <div>
                  <p class="text-danger">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ตามที่ทางบริษัท บีนีท จำกัด ได้ปรับปรุงและพัฒนามาตรฐานในการให้บริการงานรีดผ้าเพื่อให้ทางคุณแม่บ้านได้รับความน่าเชื่อถือและความไว้วางใจจากคุณลูกค้าที่มาใข้บริการยิ่งขึ้น จึงได้มีข้อกำหนดที่ทางผู้ให้บริการในระบบจะต้องมี ”โต๊ะรองรีดผ้า” เป็นอุปกรณ์พื้นฐานเพิ่มเติม ในการเข้าให้บริการ โดยทางบริษัทฯ ได้มีการเพิ่มรายได้ในส่วนของคุณแม่บ้านที่ให้บริการงานรีดผ้าเพื่อรองรับการให้บริการที่ได้มาตรฐานดังกล่าวเรียบร้อยแล้ว รวมถึงอำนวยความสะดวกให้กับทางคุณแม่บ้าน โดยได้จัดจำหน่ายโต๊ะรองรีดผ้าผ่านทางระบบของบริษัท ในราคา 499 บาท (กรณีให้ทางบริษัทจัดส่งให้ คิดค่าบริการจัดส่งเพิ่มเติม 100 บาท) และการชำระเป็นการหักจากรายได้ของคุณแม่บ้าน ซึ่งมีรายละเอียดดังต่อไปนี้</p>

                  <p>
                      <strong>1. ค่าโต๊ะรองรีดผ้า จำนวน 499 บาท (สี่ร้อยเก้าสิบเก้าบาทถ้วน) *กรณีให้ทางบริษัทจัดส่งให้ คิดค่าบริการจัดส่งเพิ่มเติม 100 บาท รวมเป็น 599 บาท ห้าร้อยเก้าสิบเก้าบาทถ้วน) โดยมีรายละเอียดดังนี้
                      </strong>
                  </p>
                  <p>
                      1.1) ระบบจะตัดยอด 20% จากรายได้ที่ได้จากการเข้าให้บริการ ตามจำนวนงานทั้งหมดที่เข้าให้บริการแต่ละสัปดาห์ (นับตามรอบการจ่ายรายได้)
                  </p>
                  <p>
                      1.2) การชำระค่าโต๊ะรองรีดผ้า จะต้องชำระจนครบ 499 บาท หรือ 599 บาท (ตามเงื่อนไขการจัดส่งสินค้า) ภายใน 60 วัน นับตั้งแต่วันที่มีการสั่งซื้อสินค้า
                  </p>
                  <p>
                      1.3) คุณแม่บ้านโอนชำระเงินค่าโต๊ะรองรีดผ้าด้วยตนเอง เพื่อให้ครบตามจำนวนเงินที่ต้องชำระตามเงื่อนไขข้อ 1.1) และ ข้อ 1.2)
                  </p>
                  <p>
                      1.4) หากระบบไม่สามารถทำการเรียกเก็บเงินค่าโต๊ะรองรีดผ้าจากคุณแม่บ้านตามข้อ 1.1) และ ข้อ 1.2) ระบบจะระงับการแสดงงานใหม่ในหน้าจอแอปพลิเคชั่นเป็นการชั่วคราว จนกว่าคุณแม่บ้านจะติดต่อมาดำเนินการชำระเงินค่าโต๊ะรองรีดผ้าด้วยตนเองตามข้อ 1.3)
                  </p>
                  <p>
                      <strong>
                          2. ความคุ้มครองและสิทธิประโยชน์
                      </strong>
                  </p>
                  <p>
                      2.1) หากผิดเงื่อนไข ข้อ 1 คุณแม่บ้านจะถูกระงับการแสดงงานใหม่ในหน้าจอแอปพลิเคชั่นเป็นการชั่วคราว
                  </p>
                  <p>
                      ***หมายเหตุ: บริษัทฯ ขอสงวนสิทธิ์ ในการระงับการให้บริการคุณแม่บ้าน ในกรณีที่ทางคุณแม่บ้านไม่สามารถดำเเนินการตามขั้นตอนดังกล่าวได้ตามกำหนดภายในระยะเวลา
                  </p>
                  <p>
                      ข้าพเจ้า นาง/นางสาว {{ professionalName }} หมายเลขผู้ให้บริการอิสระ {{ professionalId }} ได้อ่านรายละเอียดเงื่อนไข เอกสารแสดงความยินยอมให้หักรายได้ในการจัดซื้อโต๊ะรองรีดผ้า เป็นที่เข้าใจเรียบร้อยแล้ว และยิมยอมให้ทางบริษัท บีนีท จำกัด หักเงินรายได้ประจำสัปดาห์เพื่อชำระค่าโต๊ะรองรีดผ้าตามเงื่อนไขข้อ 1.
                  </p>
                  
                
              </div>
          </template>
        </template>
        <template v-else>
            <div class="text-center">
            <b-spinner variant="primary" label="Text Centered"></b-spinner>
            </div>
        </template>
       
    </section>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
export default {
  data: () => ({
    documentDate: null,
    professionalId: null,
    professionalName: null,
    loading: true
  }),
  methods: {
    async fetchCriminalHistoryCheck () {
      if (!this.professionalId) {
        this.loading = false
        this.$swal('Error', 'Invalid ID')
        return
      }
      try {
        const { data } = await axios.get(`/professionals/${this.professionalId}`)
        if (!data.error) {
          let professional = data.professional
          this.professionalId = professional.id
          this.professionalName = professional.firstname_th + ' ' + professional.lastname_th
          this.documentDate = moment(new Date()).format('DD/MM/YYYY')
        }
        this.loading = false
      } catch (error) {
        this.$swal('Error', error.message, 'error')
      }
    }
  },
  async created () {
    this.professionalId = this.$route.params.id
    this.fetchCriminalHistoryCheck()
  }
}
</script>
<style scoped>
.font__bold {
    font-weight: bold;
}
.line__text {
    text-decoration: dotted;
    text-decoration-line: underline;
}
</style>


// WEBPACK FOOTER //
// src/components/professional/IroningTableConsent.vue